import Area from '@rio-cloud/rio-uikit/Area';
import ReferenceLine from '@rio-cloud/rio-uikit/ReferenceLine';
import moment from 'moment';

export const THRESHOLD_WARNING = 60;
export const THRESHOLD_DANGER = 55;

export const dateOnXAxis = (timestamp: string) => moment(timestamp).format('D MMM');

export const thresholdAreas = [
    <Area
        key="thresholdWarningArea"
        stroke="none"
        fill="brand-warning-decent"
        fillOpacity={1}
        dataKey="threshold_warning"
        activeDot={false}
        isAnimationActive={false}
    />,
    <Area
        key="thresholdDangerArea"
        stroke="none"
        fill="brand-danger-decent"
        fillOpacity={1}
        dataKey="threshold_danger"
        activeDot={false}
        isAnimationActive={false}
    />,
];

export const thresholdReferenceLines = [
    <ReferenceLine
        key="warningReferenceLine"
        y={THRESHOLD_WARNING}
        label={{ value: `${THRESHOLD_WARNING}%`, position: 'insideBottomRight', fill: '#f88e3c' }}
        stroke="brand-warning"
        position="end"
        strokeWidth={1}
    />,
    <ReferenceLine
        key="dangerReferenceLine"
        y={THRESHOLD_DANGER}
        label={{ value: `${THRESHOLD_DANGER}%`, position: 'insideBottomRight', fill: '#e22936' }}
        stroke="brand-danger"
        strokeWidth={1}
    />,
];
